import { ROUTE_DASHBOARD_TEAM_DETAILS } from '@/constants/routes';
import { useCreateOrganization } from '@/queries/organizations.queries';
import uuidService from '@/services/uuid.service';
import { useToast } from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { object, string } from 'yup';

interface IArgs {
	isOpen: boolean;
	close: () => void;
}

export function useCreateTeamModal(args: IArgs) {
	const history = useHistory();
	const toast = useToast();
	const { t } = useTranslation();
	const createOrganizationMutation = useCreateOrganization();
	const form = useForm({
		defaultValues: {
			id: uuidService.v4(),
			name: '',
		},
		resolver: yupResolver(
			object().shape({
				id: string().required(),
				name: string().required(),
			})
		),
	});

	const handleSubmit = form.handleSubmit((values) => {
		values.id = uuidService.v4();
		return createOrganizationMutation
			.mutateAsync(values)
			.then(() => {
				form.reset();
				args.close();
				toast({ isClosable: true, title: t('Team created'), status: 'success' });
				history.push(ROUTE_DASHBOARD_TEAM_DETAILS.replace(':id', values.id));

			})
			.catch(() => {
				toast({
					isClosable: true,
					title: t('Error'),
					description: t(
						'This is usually a network error, please try again and if the problem persists contact support.'
					),
					status: 'error',
				});
			});
	});

	return { form, handleSubmit, t };
}
